/**
 * Expandable Content
 */

import $ from 'jquery';
import debounce from 'lodash/debounce';

var $expandableContent = $('.ExpandableContent');

/**
 * Determine if a 'View more' action should be visible at all, by measuring if
 * the content is bigger than the surrounding container
 */

function initExpandAction() {
  $expandableContent
    .on('expandableContent.checkHeight', function() {
      var $container = $(this).find('.ExpandableContent-container');
      var containerHeight = $container.outerHeight();
      var contentHeight = $container.children().outerHeight();

      // early return if container is already expanded
      if ($container.hasClass('is-expanded')) return;

      if (containerHeight > 0 && contentHeight > containerHeight) {
        $(this)
          .find('.ExpandableContent-action')
          .addClass('is-visible');
      } else {
        $(this)
          .find('.ExpandableContent-action')
          .removeClass('is-visible');
      }
    })
    .trigger('expandableContent.checkHeight');

  /**
   * When the window is resized, check the content height again, to determine
   * if a 'View more' action should be visible
   */

  $(window).resize(
    debounce(() => {
      $expandableContent.trigger('expandableContent.checkHeight');
    }, 300)
  );
}

/**
 * Expand/collapse the container when the 'View more/less' action is clicked
 */

function initExpandClickHandler() {
  $expandableContent.each(function() {
    var $container = $(this).find('.ExpandableContent-container');
    var containerHeight = $container.outerHeight();

    $(this).on('click', '.ExpandableContent-actionInner', function(e) {
      e.preventDefault();

      if ($container.hasClass('is-expanded')) {
        // collapse the content
        $container
          .removeClass('is-expanded')
          .css('max-height', containerHeight);
        // update the action text
        $(this).text('View more');
      } else {
        // expand the content
        $container.addClass('is-expanded').css('max-height', 'none');
        // update the action text
        $(this).text('View less');
      }
    });
  });
}

/**
 * Initialise module
 */

function init() {
  // return early if no ExpandableContent module present
  if (!$('.ExpandableContent').length) {
    return;
  }

  initExpandAction();

  initExpandClickHandler();
}

$(document).ready(init);
